import { getYear } from "date-fns";
import { range } from "lodash";

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const currentYear = getYear(new Date());
export const years = range(currentYear - 30, currentYear + 11, 1);
